// Global auth service - initialized with Stytch client at app startup
import axios from 'axios';

let stytchClient = null;

export const initAuthService = (client) => {
  stytchClient = client;
};

export const getSessionToken = () => {
  if (!stytchClient) {
    console.warn('Auth service not initialized');
    return null;
  }
  try {
    const tokens = stytchClient.session.getTokens();
    return tokens?.session_jwt || null;
  } catch (error) {
    console.error('Error getting session token:', error);
    return null;
  }
};

export const getAuthHeaders = () => {
  const token = getSessionToken();

  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

// Axios instance with auth interceptor - automatically adds Authorization header to all requests
const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const authHeaders = getAuthHeaders();
    config.headers = {
      ...config.headers,
      ...authHeaders,
    };
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
